/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A percent is a relative measure (a change from one value), while a percentage point is an absolute difference between two percentages. Going from 20% to 25% is a 5-percentage-point rise, but a 25% relative increase ((25−20)/20×100). Mixing the two is a common reporting error.`)
};

const es_pct_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un porcentaje es una medida relativa (un cambio respecto a un valor), mientras que un punto porcentual es una diferencia absoluta entre dos porcentajes. Pasar del 20% al 25% es una subida de 5 puntos porcentuales, pero un aumento relativo del 25% ((25−20)/20×100). Confundir ambos es un error común al reportar datos.`)
};

const de_pct_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Prozent ist ein relatives Maß (eine Veränderung ausgehend von einem Wert), während ein Prozentpunkt eine absolute Differenz zwischen zwei Prozentsätzen ist. Von 20% auf 25% zu gehen ist ein Anstieg um 5 Prozentpunkte, aber ein relativer Anstieg um 25% ((25−20)/20×100). Beides zu vermischen ist ein häufiger Fehler in Berichten.`)
};

const nl_pct_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een percentage is een relatieve maat (een verandering ten opzichte van één waarde), terwijl een procentpunt een absoluut verschil tussen twee percentages is. Van 20% naar 25% gaan is een stijging van 5 procentpunten, maar een relatieve stijging van 25% ((25−20)/20×100). Deze twee door elkaar halen is een veelvoorkomende rapportagefout.`)
};

const fr_pct_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un pourcentage est une mesure relative (une variation par rapport à une valeur), tandis qu’un point de pourcentage est une différence absolue entre deux pourcentages. Passer de 20 % à 25 % représente une hausse de 5 points de pourcentage, mais une augmentation relative de 25 % ((25−20)/20×100). Confondre les deux est une erreur de communication courante.`)
};

const it_pct_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una percentuale è una misura relativa (una variazione rispetto a un valore), mentre un punto percentuale è una differenza assoluta tra due percentuali. Passare dal 20% al 25% è un aumento di 5 punti percentuali, ma un aumento relativo del 25% ((25−20)/20×100). Confondere i due è un errore comune nei report.`)
};

const pt_br2_pct_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um por cento é uma medida relativa (uma variação a partir de um valor), enquanto um ponto percentual é uma diferença absoluta entre duas porcentagens. Ir de 20% para 25% é um aumento de 5 pontos percentuais, mas um aumento relativo de 25% ((25−20)/20×100). Misturar os dois é um erro comum em relatórios.`)
};

const pt_pct_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma percentagem é uma medida relativa (uma variação a partir de um valor), enquanto um ponto percentual é uma diferença absoluta entre duas percentagens. Passar de 20% para 25% é uma subida de 5 pontos percentuais, mas um aumento relativo de 25% ((25−20)/20×100). Misturar os dois é um erro comum ao reportar dados.`)
};

const ja_pct_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセントは相対的な指標（ある値からの変化）であるのに対し、パーセンテージポイントは2つのパーセント間の絶対的な差です。20%から25%への変化は5パーセンテージポイントの上昇ですが、相対的には25%の増加です（(25−20)/20×100）。この2つを混同するのは、報道などでよくある誤りです。`)
};

const zh_pct_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`百分比是相对度量（相对于某个数值的变化），而百分点是两个百分比之间的绝对差值。从 20% 到 25% 是上升了 5 个百分点，但从相对增长看是 25%（(25−20)/20×100）。混淆这两者是一个常见的报道错误。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_hub_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_hub_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_hub_faq4_a", locale)
	if (locale === "en") return en_pct_hub_faq4_a(inputs)
	if (locale === "es") return es_pct_hub_faq4_a(inputs)
	if (locale === "de") return de_pct_hub_faq4_a(inputs)
	if (locale === "nl") return nl_pct_hub_faq4_a(inputs)
	if (locale === "fr") return fr_pct_hub_faq4_a(inputs)
	if (locale === "it") return it_pct_hub_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_pct_hub_faq4_a(inputs)
	if (locale === "pt") return pt_pct_hub_faq4_a(inputs)
	if (locale === "ja") return ja_pct_hub_faq4_a(inputs)
	return zh_pct_hub_faq4_a(inputs)
};